export default __webpack_public_path__ + "static/media/feature7.21f91e8c.svg";